import { Color } from "antd/es/color-picker";
import React from "react";

const NoFound = () => {
  
  return (
    <>
      <section className="bg-success py-5">
        <div className="container">
          <div className="row align-items-center py-5">
            <div className="col-md-8 text-white">
              <h1>404</h1>
              <p>
                The Page you are looking for doesn't exist or an other error occurred.
                If you continue to experience problems please contact us.
                Click here to go back to the <a style={{color: "white"}} href="/">home page.</a>
              </p>
            </div>
            <div className="col-md-4">
              <img src="img/about-hero.svg" alt="About Hero"/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NoFound;